import axios from 'axios'

export default {
  searchStation: (name, lang) => {
    return new Promise((resolve) => {
      const params = {
        name: name,
        language: lang
      }
      axios.get('station', { params })
        .then(payload => {
          const stations = payload.data.ResultSet.Point !== undefined ? payload.data.ResultSet.Point.map((point) => { return point.Station }) : []
          resolve(stations)
        })
    })
  },
  getStation: (name, lang) => {
    return new Promise((resolve) => {
      const params = {
        name: name,
        language: lang
      }
      axios.get('station', { params })
        .then(payload => {
          const station = payload.data.ResultSet.Point
          resolve(station)
        })
    })
  }
}
